import React from 'react';
import PropTypes from 'prop-types';
import * as commonLogic from '../../../logic/CommonLogic';
import SelectModalPanel from './SelectModalPanel';

/**
 * SelectYugiType
 */
class SelectYugiType extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      yugitype: this.props.data.yugitype,
      masterList: []
    };
    this.handleModalShowChange = this.handleModalShowChange.bind(this);
    this.isModalOpen = false;
  }

  // このボックスの表示データを取得
  componentDidMount() {
    this.props.comactions.onMountedYugiType();
  }

  /**
   * メーカー選択画面を表示する
   */
  handleModalShowChange(checkedList) {
    if (this.isModalOpen) {
      this.isModalOpen = false;
      if (checkedList != null && checkedList != undefined) {
        this.props.data.smartYugikiIds = checkedList;
      }
      this.setState({ masterList: [] });
      $('#modal_yugi_select_panel').hide();
    } else {
      this.isModalOpen = true;
      this.setState({ masterList: this.props.data.itemList.yugitypeList });
      $('#modal_yugi_select_panel').show();
    }
  }

  render() {
    // const actions = this.props.actions;
    // let itemList = this.props.data.itemList.yugitypeList;

    // // 画面表示"すべて"を追加する。
    // let displayItemList = [{ vcs_yugi_type_code: '', type_mei: 'すべて' }];
    // if (itemList.length > 0) {
    //   let j = 1;
    //   for (let i = 0; i < itemList.length; i++) {
    //     displayItemList[j++] = itemList[i];
    //   }
    // }

    // const nodes = displayItemList.map((item) => {
    //   return (
    //     <option value={item.vcs_yugi_type_code} key={item.vcs_yugi_type_code}>
    //       {item.type_mei}
    //     </option>
    //   );
    // });
    // const yugitype = this.state.yugitype;
    let SelectModalPanelNodes = null;
    if (this.state.masterList.length != 0) {
      SelectModalPanelNodes = (
        <SelectModalPanel
          masterList={this.state.masterList}
          handleModalShowChange={this.handleModalShowChange}
          modalTitle={'遊戯タイプ'}
          allCheckText={'すべて'}
          checkedList={this.props.data.yugitypeIds}
          idKey={'vcs_yugi_type_code'}
          valueKey={'type_mei'}
        />
      );
    }


    return (
      <div>
        <div className="ctrl_form_title controlForm__titleSemiRequire--state_enable controlForm__text--state_enable">
          <p>遊技タイプ</p>
        </div>
        {/* <label className="select">
          <select name="pw_extraction_02" id="selectYugiType" value={yugitype} onChange={e => this.handleYugiTypeChange(e.target.value)}>
            {nodes}
          </select>
        </label> */}
        <label className="select_panel_content_parent" onClick={() => this.handleModalShowChange()}>
          <div id="selectYugi" className="select_yugi_content">
            <p>eee</p>
          </div>
        </label>

        <div id="modal_yugi_select_panel" className="modal_select_panel">
          {SelectModalPanelNodes}
        </div>

      </div>
    );
  }
}

SelectYugiType.propTypes = {
  actions: PropTypes.any.isRequired,
  comactions: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired
};

export default SelectYugiType;
